//import "chartist/dist/chartist.css";
//import "chartist-plugin-tooltips/dist/chartist-plugin-tooltip.css";

//import Chartist from 'chartist';
//import cpp from 'chartist-plugin-tooltips';

import moment from 'moment';
import Chart from 'chart.js';

import base64 from 'base64-js'

function decode(b64){
    if(window.TextDecoder){
        return new TextDecoder().decode(base64.toByteArray(b64))
    } else {
        return atob(b64)
    }
}

(function($){

    function plot(el){
        var chart = JSON.parse(decode($(el).data("chart")))
        //var period = JSON.parse(atob($(el).data("period")))
        //var data = JSON.parse(atob($(el).data("series")))

        //console.log(chart.unit);

        var datasets = chart.serie.map(function(s){
            return {
                label: s.title,
                data: s.data,
                fill: false,
                backgroundColor: s.colour,
                borderColor: s.colour
            }
        })

        var parentWidth = $(el).parent().width()
        var myWidth = parentWidth-10;
        var myHeight = (myWidth/16)*7
        $(el).width(myWidth);
        $(el).height(myHeight);
        //debugger;
        var myChart = new Chart(el, {
            type: 'line',
            data: {
                datasets:datasets
            },
            options: {
                scales: {
                    yAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: chart.unit
                        }
                    }],
                    xAxes: [{
                        type:'time',
                        time: {
                            parser:function(t){ return moment.unix(t)},
                            displayFormats: {
                                hour: 'hA ddd'
                            }
                        },
                        scaleLabel: {
                            display: true,
                            labelString: 'Date'
                        }
                    }]
                }
            }
        });
    }

    $(".chart-holder").each(function(i,el){
        setTimeout(function(){ plot(el); }, i*300 );
    })

})(jQuery);
